// Chaves de API da empresa: rótulos, situação e o endereço da documentação pública.

export const API_KEY_SCOPES = [
  { value: "read", label: "Somente leitura" },
  { value: "read_write", label: "Leitura e escrita" },
];

// `never` só existe na tela: para a API, "nunca expira" é `expiresInDays: null`
export const API_KEY_VALIDITIES = [
  { value: "never", label: "Nunca expira", days: null },
  { value: "30", label: "30 dias", days: 30 },
  { value: "90", label: "90 dias", days: 90 },
  { value: "365", label: "1 ano", days: 365 },
];

export const apiKeyScopeLabel = (scope) => API_KEY_SCOPES.find((option) => option.value === scope)?.label || scope;

/** Valor do domínio `chaveApi` do DomainStatus. A revogada vence a expirada. */
export function apiKeyStatus(key, now = new Date()) {
  if (key.revoked_at) return "revogada";
  if (key.expires_at && new Date(key.expires_at) < now) return "expirada";
  return "ativa";
}

/** A documentação da API externa fica fora do `/v1`, na raiz do back. */
export function externalDocsUrl(apiEndpoint = process.env.REACT_APP_API_ENDPOINT || "http://localhost:3044/v1/") {
  return apiEndpoint.replace(/\/v1\/?$/, "") + "/api-docs/external";
}
